import {
  AddOutlined,
  RemoveOutlined,
  ShoppingCart,
  ShoppingCartOutlined,
} from "@mui/icons-material";
import { Button, IconButton, Stack } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useHistory } from "react-router-dom";
import "./Cart.css";

// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 * 
 * @property {string} name - The name or title of the product
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */

/**
 * @typedef {Object} CartItem -  - Data on product added to cart
 * 
 * @property {string} name - The name or title of the product in cart
 * @property {string} qty - The quantity of product added to cart
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} productId - Unique ID for the product
 */

/**
 * Returns the complete data on all products in cartData by searching in productsData
 *
 * @param { Array.<{ productId: String, qty: Number }> } cartData
 *    Array of objects with productId and quantity of products in cart
 * 
 * @param { Array.<Product> } productsData
 *    Array of objects with complete data on all available products
 *
 * @returns { Array.<CartItem> }
 *    Array of objects with complete data on products in cart
 *
 */

 /**MODULE-4          MILESTONE-3-----> Fetch & Process CartData
 * Implement the generateCartItems (cartData, productData) 
 * should return complete data (name, qty, cost etc) for each products in the cart
 * Maintain a constant array in product.js which is populated with all the 
 * products data from the GET/products API call on page load so to avoid making an API call to fetch products data when needed it.
 * ensure to have products array from GET/products & carts data from GET/cart 
 * when calling generateCartItems (cartData, productData)
 * 
 * @param {*} cartData 
 * @param {*} productsData 
 */
export const generateCartItemsFrom = (cartData, productsData) => {
  // debugger;
  let newArray= cartData.map((item)=>({
    ...item,
    ...productsData.find((product)=>item.productId===product._id),
  }))
 
  // console.log("newArray :", newArray)

  return newArray
};

/**
 * Get the total value of all products added to the cart
 *
 * @param { Array.<CartItem> } items
 *    Array of objects with complete data on products added to the cart
 *
 * @returns { Number }
 *    Value of all items in the cart
 *
 */
export const getTotalCartValue = (items = []) => {
  let num=0;
  let numArray = items.map((item)=>{
    const {
      qty,
    
      cost
    }= item
 
    return (qty*cost)
  })
  for(let i=0; i<numArray.length; i++){
    num+=numArray[i]
  }
  return num
 
};


// TODO: CRIO_TASK_MODULE_CHECKOUT - Implement function to return total cart quantity
/**
 * Return the sum of quantities of all products added to the cart
 *
 * @param { Array.<CartItem> } items
 *    Array of objects with complete data on products in cart
 *
 * @returns { Number }
 *    Total quantity of products added to the cart
 *
 */
export const getTotalItems = (items = []) => {
  const numbers=[]
  const totalProducts = items.map((item, index)=>{
    const{
      productId
    }=item

     numbers.push(productId[index])
     
  })
  // console.log(numbers)
  // console.log(totalProducts)
  return numbers.length
  
};


/**
 * Component to display the current quantity for a product and + and - buttons to update product quantity on cart
 * 
 * @param {Number} value
 *    Current quantity of product in cart
 * 
 * @param {Function} handleAdd
 *    Handler function which adds 1 more of a product to cart
 * 
 * @param {Function} handleDelete
 *    Handler function which reduces the quantity of a product in cart by 1
 * 
 * @param {Boolean} isReadOnly
 *    If product quantity on cart is to be displayed as read only without the + - options to change quantity
 * 
 */
const ItemQuantity = ({
  value,
  handleAdd,
  handleDelete,
  isReadOnly
}) => {
  if(isReadOnly){
    return(
      <Stack>
       <Box padding="0.5rem" data-testid="item-qty">
       Qty:{value}
      </Box> 
      </Stack>
    )
  }
  return (
    <Stack direction="row" alignItems="center">
      <IconButton size="small" color="primary" onClick={handleDelete}>
        <RemoveOutlined />
      </IconButton>
      <Box padding="0.5rem" data-testid="item-qty">
        {value}
      </Box>
      <IconButton size="small" color="primary" onClick={handleAdd}>
        <AddOutlined />
      </IconButton>
    </Stack>
  );
};

/**
 * Component to display the Cart view
 * 
 * @param { Array.<Product> } products
 *    Array of objects with complete data of all available products
 * 
 * @param { Array.<Product> } items
 *    Array of objects with complete data on products in cart
 * 
 * @param {Function} handleDelete
 *    Current quantity of product in cart
 * 
 * @param {Boolean} isReadOnly
 *    If product quantity on cart is to be displayed as read only without the + - options to change quantity
 * 
 */
const Cart = ({
  products,
  items = [],
  handleQuantity,
  isReadOnly
}) => {
const history=useHistory()
const checkOut = ()=>{
  history.push("/checkout")
}
// var token= localStorage.getItem('token')

  if (!items.length) {
    return (
      <Box className="cart empty">
        <ShoppingCartOutlined className="empty-cart-icon" />
        <Box color="#aaa" textAlign="center">
          Cart is empty. Add more items to the cart to checkout.
        </Box>
      </Box>
    );
  }

  return (
    
    <>
    
      <Box className="cart">
        {/* TODO: CRIO_TASK_MODULE_CART - Display view for each cart item with non-zero quantity */}
        {items.map((item)=>
          
           (<Box key={item.productId}>
             { item.qty > 0 ? 
             (<Box display="flex" alignItems="flex-start" padding="1rem" >
             <Box className="image-container">
                 <img
                     // Add product image
                     src={item.image}
                     // Add product name as alt eext
                     alt={item.name}
                     width="100%"
                     height="100%"
                 />
             </Box>
             <Box
                 display="flex"
                 flexDirection="column"
                 justifyContent="space-between"
                 height="6rem"
                 paddingX="1rem"
             >
                 <div>{item.name}</div>
                 <Box
                     display="flex"
                     justifyContent="space-between"
                     alignItems="center"
                 >
                 <ItemQuantity 
                 value={item.qty}
                  handleAdd={async()=>{await handleQuantity(localStorage.getItem('token'),items,products,item.productId,item.qty+1)}} 
                 handleDelete={async()=>{await handleQuantity(localStorage.getItem('token'),items,products,item.productId,item.qty-1)}}
                 isReadOnly={isReadOnly}
                 // Add required props by checking implementation
                 />
                 <Box padding="0.5rem" fontWeight="700">
                     ${item.cost}
                 </Box>
                 </Box>
             </Box>
         </Box>
                   )
               
           :null  } 
            

        </Box>)

             )}
        <Box
          padding="1rem"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box color="#3C3C3C" alignSelf="center">
            Order total
          </Box>
          <Box
            color="#3C3C3C"
            fontWeight="700"
            fontSize="1.5rem"
            alignSelf="center"
            data-testid="cart-total"
          >
            ${getTotalCartValue(items)}
            
          </Box>
        </Box>

        <Box display="flex" justifyContent="flex-end" className="cart-footer">
          {
            isReadOnly ? null
             :<Button
            color="primary"
            variant="contained"
            startIcon={<ShoppingCart />}
            className="checkout-btn"
            onClick={checkOut}
            
          >
            Checkout
          </Button>
          }
          
        </Box>
        
      </Box>
      {
          isReadOnly &&
          ( <Box className="cart">
            <Box display="flex" alignItems="flex-start" padding="1rem" >
            <Box 
            display="flex"
            flexDirection="row"
            justifyContent="flex-start"
            marginY="1rem"
            fontWeight="700"
            fontSize="1.5rem"
            >
            <div>Order Details</div>
            </Box>
              
        </Box>
        <Box
          padding="0.5rem"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box color="#3C3C3C" alignSelf="center">
            Products
          </Box>
          <Box
            color="#3C3C3C"           
            alignSelf="center"
          >
            {getTotalItems(items)}
          </Box>
        </Box>
        <Box
          padding="0.5rem"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box color="#3C3C3C" alignSelf="center">
            Sub total
          </Box>
          <Box
            color="#3C3C3C"           
            alignSelf="center"           
          >
            ${getTotalCartValue(items)}
          </Box>
        </Box>
        <Box
          padding="0.5rem"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box color="#3C3C3C" alignSelf="center">
            Shipping Charges
          </Box>
          <Box
            color="#3C3C3C"
            alignSelf="center"           
          >
            $0
          </Box>
        </Box>
        <Box
          padding="0.5rem"
          display="flex"        
          justifyContent="space-between"
          alignItems="center"
        >
          <Box color="#3C3C3C" alignSelf="center" fontWeight="700"
          fontSize="1.5rem">
            Total
          </Box>
          <Box
            color="#3C3C3C"
            fontWeight="700"
            fontSize="1.5rem"
            alignSelf="center"
            data-testid="cart-total"
          >
            ${getTotalCartValue(items)}
          </Box>
        </Box>
        </Box>)

        }
    </>
  );
};

export default Cart;
